exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-found {\n  padding: 30vh 0;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/views/not-found/not-found.scss
// module id = 287
// module chunks = 0